"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const configLinks_1 = require("@geome/react-components-next/lib/components/configLinks");
const social_youtube_svg_1 = __importDefault(require("../images/social-youtube.svg"));
const social_linkedin_svg_1 = __importDefault(require("../images/social-linkedin.svg"));
const social_facebook_svg_1 = __importDefault(require("../images/social-facebook.svg"));
const social_instagram_svg_1 = __importDefault(require("../images/social-instagram.svg"));
const social_twitter_svg_1 = __importDefault(require("../images/social-twitter.svg"));
const linkIcons = {
    social: {
        youtube: (0, jsx_runtime_1.jsx)("img", { src: social_youtube_svg_1.default, "aria-hidden": true }),
        linked_in: social_linkedin_svg_1.default,
        facebook: social_facebook_svg_1.default,
        instagram: social_instagram_svg_1.default,
        twitter: social_twitter_svg_1.default,
    },
};
const Footer = () => ((0, jsx_runtime_1.jsx)("div", { className: "footer", children: (0, jsx_runtime_1.jsx)(configLinks_1.ConfigLinks, { configPath: "station_page.", sectionName: "footer", linkIcons: linkIcons }) }));
exports.Footer = Footer;
